<div class="row" *ngIf="job">
    <div class="col-lg-12">
        <div class="main-box clearfix" style="min-height: 200px;">
            <header class="main-box-header pt-0 clearfix col-xs-offset-1 col-xs-10 text-center" *ngIf="step2Error?.hasErrorFlag">
                <h2 class="has-error">
                    <span class="help-block">
                        <em>*</em> {{step2Error?.errorMessage}}
                    </span>
                </h2>
            </header>
            <div class="row" style="margin-top: 40px; margin-bottom: 40px;">
                <div class="col-xs-offset-1 col-xs-6">
                    <div class="row">
                        <div class="col-xs-12">
                            <!-- job title -->
                            <div class="form-group" [class.has-error]="editTitleFlag && step2Submitted && !(job.title && job.title !== '')">
                                <label>Title <em>*</em> : </label>
                                <a href="" (click)="showJobProfileCallback.emit(); $event.preventDefault()" *ngIf="!editTitleFlag" style="color: black; font-size: 100%; font-weight: bold;" title="{{job.title}}">
                                    <span class="control-label">{{job.title}}</span>
                                </a>
                                <i class="fas fa-pencil-alt cursor-pointer ml-2" title="Edit Title" (click)="editTitleToggleCallback.emit()" *ngIf="!editTitleFlag"></i>
                                <input *ngIf="editTitleFlag" type="text" class="form-control" id="jobTitle"
                                    [(ngModel)]="job.title" name="jobTitle" (ngModelChange)="onJobTitleChange()"
                                    style="border-width: 1px;width: 75%" required>
                            </div>
                        </div>
                        <div class="col-xs-12">
                            <div class="row">
                                <div class="col-xs-5">
                                    <!-- company name -->
                                    <div class="form-group">
                                        <label>Belongs to <em *ngIf="editBUFlag && clientOrBUIsRequiredFlag">*</em> : </label>
                                        <i style="display: inline-block; margin-right: 2px;" *ngIf="job.clientorbu?.companyType === 'Corporation'" class="fas fa-share-alt"></i>
                                        <span *ngIf="!editBUFlag" title="{{job.clientorbu?.name}}"
                                              style="font-size: 12px; font-weight: bold; cursor:pointer;">{{job.clientorbu?.name}}</span>
                                        <i *ngIf="currentJobStatus == 'DRAFT'"
                                           class="fas fa-pencil-alt cursor-pointer ml-2" title="Edit {{clientOrBuLabel}}" (click)="editBUToggleCallback.emit()"></i>
                                        <select *ngIf="editBUFlag" class="form-control" name="jobClient" id="jobClient" style="border-width: 1px;width: 100%"
                                            [value]="job.clientorbu?.id"
                                            (change)="onClientOrBuIdChange($event.target.value)"
                                            [required]="clientOrBUIsRequiredFlag">
                                            <option *ngFor="let client of clientorbulist; trackBy: trackById" [value]="client.id">{{client.displayName}}</option>
                                        </select>
                                    </div>
                                    <!-- Client Bus -->
                                    <div class="form-group" *ngIf="userDetails?.company?.companyType === MESSAGECONSTANTS.COMPANY_TYPES.STAFFING && (job.isSharedClientRequisition || (job.sharedClientBuOrCorpId !== null && job.sharedClientBuOrCorpId !== undefined)) && !isLoadingSharedClientBus">
                                        <label for="sharedClientBuOrCorpSelect">
                                            <span>Client's Bus</span>
                                            <em> * </em> :
                                        </label>
                                        <select class="form-control" name="sharedClientBuOrCorpSelect" id="sharedClientBuOrCorpSelect"
                                            [value]="sharedClientBuOrCorp?.id"
                                            (change)="onSharedClientBuOrCorpChange($event.target.value)"
                                            [disabled]="currentJobStatus !== 'DRAFT'"
                                            required>
                                            <option *ngFor="let bu of sharedClientBus" [value]="bu.id">{{bu.name}}</option>
                                        </select>
                                    </div>
                                    <div class="form-group" *ngIf="userDetails?.company?.companyType === MESSAGECONSTANTS.COMPANY_TYPES.STAFFING && (job.isSharedClientRequisition || job.sharedClientBuOrCorpId !== null) && isLoadingSharedClientBus">
                                        <div class="skeleton-container d-inline-block" style="width: 150px;">
                                            <div class="skeleton-paragraph width-100 skeleton-loading my-0"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <!-- Location -->
                                    <div class="form-group">
                                        <label>Location : </label>
                                        <span title="{{job.locationLabel}}" style="font-size: 12px; font-weight: bold; cursor:pointer;">{{job.locationLabel}}</span>
                                        <i class="fas fa-pencil-alt cursor-pointer ml-2" title="Edit Location" (click)="updateLocationCallback.emit()"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Requisition Number -->
                        <div class="col-xs-5">
                            <div class="form-group" [class.has-error]="step2Submitted && !(job.requisitionNumber && job.requisitionNumber !== '')">
                                <label for="requisitionNumber" class="control-label">
                                    Requisition Number <em>*</em> :
                                </label>
                                <input type="text" class="form-control" id="requisitionNumber" [(ngModel)]="job.requisitionNumber"
                                    (ngModelChange)="requisitionNumberChangeCallback.emit()" name="requisitionNumber" required style="border-width: 1px;">
                            </div>
                        </div>
                        <!-- Number of Openings -->
                        <div class="col-xs-5">
                            <div class="form-group" [class.has-error]="step2Submitted && !(job.openings >= 1)">
                                <label for="openings" class="control-label">
                                    Number of Openings <em>*</em> :
                                </label>
                                <input type="number" class="form-control" [(ngModel)]="job.openings" id="openings"
                                    name="openings" min="1" style="width:39%; border-width: 1px;" required
                                    (ngModelChange)="openingsChangeCallback.emit()">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">
                            <!-- Job type dropdown -->
                            <div class="form-group" [class.has-error]="step2Submitted && job.jobType == null">
                                <label for="jobtype" class="control-label">Job Type <em>*</em> : </label>
                                <ng-select name="jobtype" id="jobtype" [items]="jobTypeList" bindLabel="name"
                                    placeholder="None selected" [(ngModel)]="jobTypeSelection" [closeOnSelect]="true"
                                    [ngClass]="{'multi-select-error': step2Submitted && job.jobType == null}"
                                    (change)="onJobTypeChange(jobTypeSelection ? [jobTypeSelection] : [])">
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-xs-5" *ngIf="job.jobType === 'CONTRACTTOHIRE' || job.jobType === 'CONTRACTOR'">
                            <!-- Contract Duration -->
                            <div class="form-group" [class.has-error]="step2Submitted && !job.contractDuration">
                                <label for="contractDuration" class="control-label">Contract Duration (in months)<em>*</em> : </label>
                                <select class="form-control"
                                    name="contractDuration" id="contractDuration" style="max-width:140px"
                                    [(ngModel)]="job.contractDuration"
                                    required>
                                    <option *ngFor="let duration of contractDurations" [value]="duration" title="{{duration}}">
                                        {{duration}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">
                            <!-- Work location dropdown -->
                            <div class="form-group"
                                [class.has-error]="step2Submitted && job.workLocationIds?.length === 0">
                                <label for="workLocations" class="control-label">Work Locations <em>*</em> : </label>
                                <ng-select name="workLocations" id="workLocations" [items]="workLocationsList" bindLabel="name"
                                    [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedWorkLocationsList"
                                    [ngClass]="{'multi-select-error': step2Submitted && job.workLocationIds?.length === 0}"
                                    (change)="onWorkLocationsChange(selectedWorkLocationsList)" placeholder="None selected">
                                    <ng-template ng-header-tmp>
                                        <div class="d-flex">
                                            <div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('workLocations', 'selectAll')">Select All</div>
                                            <div class="custom-ng-select-btn" (click)="selectRemoveAll('workLocations', 'removeAll')">Select None</div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-multi-label-tmp let-items="items">
                                        <span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- salary -->
                        <div class="col-xs-12">
                            <div class="form-group">
                                <label class="control-label">
                                    {{salaryLabel}} :
                                </label>
                                <div>
                                    <div class="upload-req-radio" style="display: inline;">
                                        <input type="radio" name="salaryType" id="salaryTypeSpecific" [value]="'SPECIFIC'"
                                            (change)="salaryTypeChangeCallback.emit('SPECIFIC')"
                                            [checked]="job.jobSalary?.salaryType === 'SPECIFIC'">
                                        <label for="salaryTypeSpecific">Specific</label>
                                    </div>
                                    <div class="upload-req-radio" style="display: inline;">
                                        <input type="radio" name="salaryType" id="salaryTypeRange" [value]="'RANGE'"
                                            (change)="salaryTypeChangeCallback.emit('RANGE')"
                                            [checked]="job.jobSalary?.salaryType === 'RANGE'">
                                        <label for="salaryTypeRange">Range</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-3" *ngIf="job.jobSalary?.salaryType == 'SPECIFIC'">
                            <div class="form-group" [class.has-error]="!job.jobSalary?.maxSalary">
                                <label class="control-label" for="amount">Value:</label>
                                <input type="number" class="form-control" id="amount" name="amount" min="1"
                                    required [(ngModel)]="job.jobSalary.maxSalary">
                            </div>
                        </div>
                        <div class="form-group col-xs-3" *ngIf="job.jobSalary?.salaryType == 'SPECIFIC'"
                            [class.has-error]="step2Submitted && !job.jobSalary?.currency">
                            <label class="control-label" for="currency">Currency:</label>
                            <select class="form-control" name="currency" id="currency" [(ngModel)]="job.jobSalary.currency" required>
                                <option *ngFor="let currency of currencyCodes" [value]="currency" title="{{currency}}">{{currency}}</option>
                            </select>
                        </div>
                        <div class="form-group col-xs-3" *ngIf="job.jobSalary?.salaryType == 'SPECIFIC'"
                            [class.has-error]="step2Submitted && !job.jobSalary?.salaryDuration">
                            <label class="control-label" for="salaryDuration">Per:</label>
                            <select class="form-control" name="salaryDuration" id="salaryDuration"
                                [(ngModel)]="job.jobSalary.salaryDuration" required>
                                <option *ngFor="let salaryDuration of salaryDurationOptions" [value]="salaryDuration.value" title="{{salaryDuration.name}}">
                                    {{salaryDuration.name}}
                                </option>
                            </select>
                        </div>
                        <div class="col-xs-12" *ngIf="job.jobSalary?.salaryType == 'RANGE'">
                            <div class="form-group col-xs-2" [class.has-error]="!(job.jobSalary?.minSalary && job.jobSalary?.maxSalary)">
                                <label class="control-label" for="minSalary">From:</label>
                                <input type="number" class="form-control" name="minSalary" id="minSalary" min="1"
                                    required [(ngModel)]="job.jobSalary.minSalary">
                            </div>
                            <div class="form-group col-xs-2" [class.has-error]="!(job.jobSalary?.minSalary && job.jobSalary?.maxSalary)">
                                <label class="control-label" for="maxSalary">To:</label>
                                <input type="number" class="form-control" name="maxSalary" id="maxSalary" min="{{job.jobSalary?.minSalary}}"
                                    required [(ngModel)]="job.jobSalary.maxSalary">
                            </div>
                            <div class="form-group col-xs-2" [class.has-error]="step2Submitted && !job.jobSalary?.currency">
                                <label class="control-label" for="currency">Currency:</label>
                                <select class="form-control" name="currency" id="currency" [(ngModel)]="job.jobSalary.currency" required>
                                    <option *ngFor="let currency of currencyCodes" [value]="currency" title="{{currency}}">{{currency}}</option>
                                </select>
                            </div>
                            <div class="form-group col-xs-3" [class.has-error]="step2Submitted && !job.jobSalary?.salaryDuration">
                                <label class="control-label" for="salaryDuration">Per:</label>
                                <select class="form-control" name="salaryDuration" id="salaryDuration"
                                    [(ngModel)]="job.jobSalary.salaryDuration" required>
                                    <option *ngFor="let salaryDuration of salaryDurationOptions" [value]="salaryDuration.value" title="{{salaryDuration.name}}">
                                        {{salaryDuration.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <!-- Sponsorship -->
                            <div>
                                <label class="control-label">Sponsorship <em>*</em> : </label>
                                <div>
                                    <div style="display:inline">
                                        <div class="upload-req-radio" style="display: inline; ">
                                            <input type="radio" name="sponsorshipProvided" id="sponsorshipProvided" [value]="true"
                                                [(ngModel)]="job.sponsorshipProvided" (ngModelChange)="sponsorshipProvidedSelectedCallback.emit()">
                                            <label for="sponsorshipProvided">Yes</label>
                                        </div>
                                        <div class="upload-req-radio" style="display: inline;">
                                            <input type="radio" name="sponsorshipProvided" id="sponsorshipNotProvided" [value]="false"
                                                [(ngModel)]="job.sponsorshipProvided" (ngModelChange)="sponsorshipProvidedSelectedCallback.emit()">
                                            <label for="sponsorshipNotProvided">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Sponsorship types -->
                            <div class="form-group" [class.has-error]="step2Submitted && job.sponsorshipProvided && job.sponsorships?.length == 0">
                                <div class="col-xs-10 d-flex flex-wrap" style="padding-left:0">
                                    <div class="checkbox-nice d-flex mr-3 mb-2" *ngFor="let sponsorship of sponsorshipList; let i = index">
                                        <input type="checkbox" id="{{sponsorship.value}}" [checked]="sponsorship.selected"
                                            (click)="onSponsorshipToggle(i, sponsorship)"/>
                                        <label for="{{sponsorship.value}}" class="control-label">{{sponsorship.name}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-5">
                    <div class="row">
                        <div class="col-xs-11">
                            <!-- Recruiters dropdown -->
                            <div class="form-group" [class.has-error]="step2Submitted && job.recruiters?.length == 0">
                                <label for="recruiter" class="control-label">Recruiters/Admins <em>*</em> : </label>
                                <ng-select name="recruiter" id="recruiter" [items]="recruiterList" bindLabel="fullName"
                                    [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedRecruiters" placeholder="None selected"
                                    [ngClass]="{'multi-select-error': step2Submitted && job.recruiters?.length == 0}"
                                    (change)="onRecruitersChange(selectedRecruiters)">
                                    <ng-template ng-header-tmp>
                                        <div class="d-flex">
                                            <div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('recruiters', 'selectAll')">Select All</div>
                                            <div class="custom-ng-select-btn" (click)="selectRemoveAll('recruiters', 'removeAll')">Select None</div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-multi-label-tmp let-items="items">
                                        <span class="ng-value">{{ getMultiSelectSummary(items, 'fullName') }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-11" *ngIf="isCorporate">
                            <div class="form-group">
                                <label for="hiringManager" class="control-label">
                                    {{MESSAGECONSTANTS.LABLES.HIRINGMANAGERS}}:
                                </label>
                                <ng-select name="hiringManager" id="hiringManager" [items]="hiringManagerList" bindLabel="fullName"
                                    [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedHiringManagers"
                                    (change)="onHiringManagersChange(selectedHiringManagers)">
                                    <ng-template ng-header-tmp>
                                        <div class="d-flex">
                                            <div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('hiringManagers', 'selectAll')">Select All</div>
                                            <div class="custom-ng-select-btn" (click)="selectRemoveAll('hiringManagers', 'removeAll')">Select None</div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-multi-label-tmp let-items="items">
                                        <span class="ng-value">{{ getMultiSelectSummary(items, 'fullName') }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <!-- POC dropdown -->
                    <div class="col-xs-11 form-group" *ngIf="!isCorporate">
                        <label for="poc" class="control-label">
                            <span class="fas fa-user-tie"></span>
                            Point of Contact :
                        </label>
                        <ng-select name="poc" id="poc" [items]="pocs" bindLabel="fullName"
                            placeholder="None selected" [(ngModel)]="pocSelection" [closeOnSelect]="true"
                            (change)="onPocChange(pocSelection ? [pocSelection] : [])">
                        </ng-select>
                    </div>

                    <div class="row form-group" *ngIf="job.hiringManagers?.length > 0 && isCorporate"
                        [class.has-error]="step2Submitted && job.hiringManagers?.length > 0 && !primaryHiringManagerId">
                        <h5 style="margin-left:10px" class="control-label">Primary Hiring Manager <em>*</em> : </h5>
                        <div class="col-xs-6" *ngFor="let manager of primaryHiringManagerList">
                            <div class="upload-req-radio" style="display: inline">
                                <input type="radio" name="primaryHiringManager" id="{{manager.userId}}" [value]="manager.userId"
                                    [(ngModel)]="primaryHiringManagerId" (click)="primaryHiringManagerSelectedCallback.emit(manager)">
                                <label for="{{manager.userId}}">{{manager.fullName}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="row" style="padding-left:8px" *ngIf="!clientOrBUIsRequiredFlag">
                        <div class="col-xs-11 main-box">
                            <div class="col-xs-11">
                                <h4 class="text-center" style="padding-top:13px">Vendor Settings</h4>
                                <!-- Vendors dropdown -->
                                <div class="form-group">
                                    <label for="vendor" class="control-label">{{MESSAGECONSTANTS.LABLES.VENDORS}} : </label>
                                    <ng-select name="vendor" id="vendor" [items]="vendorsList" bindLabel="vendorName"
                                        [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedVendors"
                                        (change)="onVendorsChange(selectedVendors)">
                                        <ng-template ng-header-tmp>
                                            <div class="d-flex">
                                                <div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('vendors', 'selectAll')">Select All</div>
                                                <div class="custom-ng-select-btn" (click)="selectRemoveAll('vendors', 'removeAll')">Select None</div>
                                            </div>
                                        </ng-template>
                                        <ng-template ng-multi-label-tmp let-items="items">
                                            <span class="ng-value">{{ getMultiSelectSummary(items, 'vendorName') }}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                            <!-- POC dropdown -->
                            <div class="col-xs-11 form-group" *ngIf="selectedVendors?.length>0" [class.has-error]="step2Submitted && job.pointOfContactUserId == null">
                                <label for="sharedPoc" class="control-label">Primary Point of Contact <em>*</em> : </label>
                                <ng-select name="sharedPoc" id="sharedPoc" [items]="sharedJobPocs" bindLabel="fullName"
                                    placeholder="None selected" [(ngModel)]="pocSelection" [closeOnSelect]="true"
                                    [ngClass]="{'multi-select-error': step2Submitted && job.pointOfContactUserId == null}"
                                    (change)="onPocChange(pocSelection ? [pocSelection] : [])">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="showEndClientSection">
                        <div class="col-xs-12">
                            <!-- End Client -->
                            <div class="form-group ml-2">
                                <label for="endClient" class="control-label">End Client : </label>
                                <div class="d-flex align-items-center">
                                    <div style="min-width: 220px; flex: 1;">
                                        <ng-select name="endClient" id="endClient" [items]="endClientSearchResults" bindLabel="name"
                                            placeholder="Type name to search for end client." [(ngModel)]="endClientSelection"
                                            [closeOnSelect]="true" [loading]="isLoadingEndClientSearch"
                                            typeToSearchText="Type name to search for end client."
                                            (search)="onEndClientSearch($event)"
                                            (change)="onEndClientChange(endClientSelection ? [endClientSelection] : [])"
                                            (clear)="onEndClientChange([])">
                                        </ng-select>
                                    </div>
                                    <div class="px-2 d-flex">
                                        <button type="button" class="btn btn-info" (click)="addEditEndClientCallback.emit('Add')"
                                            *ngIf="!endClient || endClient.length === 0" title="Add End Client">
                                            <span class="fas fa-plus-circle"></span> Add
                                        </button>
                                        <button type="button" class="btn btn-info" (click)="addEditEndClientCallback.emit('Manage')"
                                            *ngIf="endClient?.length > 0 && !isManageEndClient" title="Manage End Client">Manage
                                        </button>
                                        <button type="button" class="btn btn-info mr-2" (click)="addEditEndClientCallback.emit('Edit')"
                                            *ngIf="endClient?.length > 0 && isManageEndClient" title="Edit End Client">
                                            <span class="fas fa-pencil-alt mr-2"></span>Edit
                                        </button>
                                        <button type="button" class="btn btn-danger" (click)="addEditEndClientCallback.emit('Delete')"
                                            *ngIf="endClient?.length > 0 && isManageEndClient" title="Delete End Client">
                                            <span class="fas fa-trash-alt mr-2"></span>Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <!-- Notes -->
                            <div class="form-group ml-2">
                                <label>Notes : </label>
                                <!-- Voice Input -->
                                <div class="mb-2">
                                    <app-voice-input
                                        (transcriptReady)="voiceTranscriptCallback.emit($event)"
                                        sourceScreen="REQUISITION"
                                        [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                                        [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                                        [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                                        [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                                    </app-voice-input>
                                </div>
                                <textarea class="form-control" wrap="hard" style="border-width: 1px;width:90%" rows="3"
                                    id="notes" [(ngModel)]="job.requisitionNote" name="notes">
                                </textarea>
                                <!-- Formalize Text -->
                                <app-formalize-comment
                                    [inputText]="job.requisitionNote"
                                    (outputText)="receiveFormalizedCommentCallback.emit($event)"
                                    sourceScreen="REQUISITION"
                                    [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                                    [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                                    [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                                    [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                                </app-formalize-comment>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
